const userHasRequiredRoles = (usuarioLogado, requiredRoles) => {
    let hasAccess = true;
    const authorities = usuarioLogado.authorities.map(
        targetAuthority => targetAuthority.authority
    );

    for (let i = 0; i < requiredRoles.length; i++) {
        if (!authorities.includes(requiredRoles[i])) {
            hasAccess = false;
            break;
        }
    }

    return hasAccess;
};

export default { userHasRequiredRoles };
